import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

const selectors = {
  slider: "[data-locations]",
  pin: "[data-locations-pin]",
  list: "[data-locations-list]",
  listClose: "[data-locations-list-close]",
  listExpand: "[data-locations-list-expand]",
};

const highlightPin = (activeIndex, pins) =>
  pins.forEach((pin, index) => pin.classList[index === activeIndex ? "add" : "remove"]("active"));

const initPins = (pins, swiper, list) => {
  pins.forEach((pin, index) =>
    pin.addEventListener("click", () => {
      if (window.matchMedia("(width >= 1024px)").matches) {
        swiper.slideTo(index);
      } else {
        const listItems = list.lastElementChild.lastElementChild.children;
        const isActive = list.classList.contains("active");

        if (!isActive) list.classList.add("active");
        listItems[index].scrollIntoView({ behavior: "smooth" });
      }

      highlightPin(index, pins);
    })
  );
};

const initCloseButton = (button, pins, list) =>
  button.addEventListener("click", () => {
    list.classList.remove("active", "expanded");
    highlightPin(-1, pins);
  });

const expandList = (list) => {
  let touchStartY;

  return {
    handleTouchStart: ({ changedTouches }) => (touchStartY = changedTouches[0].clientY),
    handleTouchEnd: ({ changedTouches }) => {
      const touchEndY = changedTouches[0].clientY;
      const isExpanded = list.classList.contains("expanded");

      if (!touchStartY || !touchEndY) return;
      if (isExpanded && touchStartY < touchEndY) list.classList.remove("expanded");
      if (!isExpanded && touchStartY > touchEndY) list.classList.add("expanded");

      touchStartY = 0;
    },
  };
};

const initExpandButton = (button, list) => {
  const { handleTouchStart, handleTouchEnd } = expandList(list);

  button.addEventListener("touchstart", handleTouchStart);
  button.addEventListener("touchend", handleTouchEnd);
};

const initSwiper = (container, pins) =>
  new Swiper(container.querySelector(".swiper"), {
    enabled: false,
    slidesPerView: "auto",
    speed: 0,

    breakpoints: {
      1024: {
        enabled: true,
        slidesPerView: "1",
      },
    },

    navigation: {
      prevEl: container.querySelector(".swiper-navigation.prev"),
      nextEl: container.querySelector(".swiper-navigation.next"),
    },

    pagination: {
      el: container.querySelector(".swiper-pagination"),
    },

    on: {
      init: ({ realIndex }) => {
        if (!window.matchMedia("(width >= 1024px)").matches) return;

        highlightPin(realIndex, pins);
      },
      realIndexChange: ({ realIndex }) => highlightPin(realIndex, pins),
    },
  });

const init = (container) => {
  Swiper.use([Navigation, Pagination]);

  const pins = container.querySelectorAll(selectors.pin);
  const list = container.querySelector(selectors.list);
  const listClose = container.querySelector(selectors.listClose);
  const listExpand = container.querySelector(selectors.listExpand);
  const swiper = initSwiper(container, pins);

  initPins(pins, swiper, list);
  initCloseButton(listClose, pins, list);
  initExpandButton(listExpand, list);
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const containers = document.querySelectorAll(selectors.slider);

    containers?.forEach(init);
  },
  {
    once: true,
  }
);
